import { DataSource, DateRangeFilter, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTransferToCommissions extends Layout {
    daterangefilterFilter: DateRangeFilter;
    excludabletextboxManifest: ExcludableTextbox;
    excludabletextboxOrderMove: ExcludableTextbox;
    sourceTransferToCommissions: DataSource;
    textboxDrayMove: Textbox;
    textboxTransferBy: Textbox;
}
